<template>
  <div class="content">
    <base-header class="pb-6 bg-gradient" type="">
      <b-row align-v="center" class="py-4">
        <!-- b-col lg="4">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col -->

        <b-col lg="12">
          <template v-if="offer.is_car">
            <button class="btn btn-primary" @click="toggleOfferType()">
              <i class="fa fa-car"></i>
              PKW
            </button>
            <button class="btn" @click="toggleOfferType()">
              <i class="fa fa-bus"></i>
              Nutzfahrzeug
            </button>
          </template>

          <template v-if="!offer.is_car">
            <button class="btn" @click="toggleOfferType()">
              <i class="fa fa-car"></i>
              PKW
            </button>
            <button class="btn btn-primary" @click="toggleOfferType()">
              <i class="fa fa-bus"></i>
              Nutzfahrzeug
            </button>
          </template>
          
          <template v-if="!offer.is_company">
            <button class="btn btn-primary" @click="toggleOfferCompany()">
              <i class="fa fa-user"></i>
              Privatkunde
            </button>
            <button class="btn" @click="toggleOfferCompany()">
              <i class="fa fa-university"></i>
              Geschäftskunde
            </button>
          </template>

          <template v-if="offer.is_company">
            <button class="btn" @click="toggleOfferCompany()">
              <i class="fa fa-user"></i>
              Privatkunde
            </button>
            <button class="btn btn-primary" @click="toggleOfferCompany()">
              <i class="fa fa-university"></i>
              Geschäftskunde
            </button>
          </template>



          <template v-if="offer.slected_insurance == 'kravag'">
            <button class="btn" @click="setInsurance('softfair')">
              <i class="fa fa-car"></i>
              SoftFair
            </button>
            <button class="btn btn-primary" @click="setInsurance('kravag')">
              <i class="fa fa-bus"></i>
              Kravag
            </button>
          </template>

          <template v-if="offer.slected_insurance == 'softfair'">
            <button class="btn btn-primary" @click="setInsurance('softfair')">
              <i class="fa fa-car"></i>
              SoftFair
            </button>
            <button class="btn" @click="setInsurance('kravag')">
              <i class="fa fa-bus"></i>
              Kravag
            </button>
          </template>

        </b-col>

      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <b-row class="card-wrapper">
        <b-col lg="6" id="main">
          <b-row class="card-wrapper">
            <b-col lg="12">
              <card>
                <!-- Card header -->

                <b-row align-v="center" slot="header">
                  <b-col cols="8">
                    <h3 slot="header" class="mb-0">
                      <i class="fa fa-user"></i>
                        Kundenangebot rechnen
                    </h3>
                  </b-col>
                  <b-col class="text-right">
                    <a href="#!" class="btn btn-sm btn-primary" @click="setDefaults()">Neues Angebot</a>
                    <!-- a href="#!" class="btn btn-sm btn-primary" @click="submitToApi()">Jetzt kalkulieren</a -->
                  </b-col>
                </b-row>

                <div class="Einstufung" v-if="currentAccount.hasRole('admin')"> 
        Admin: Einstufung: 
         {{ offer.leveling_type }}: {{ offer.enstg[offer.leveling_type] }} 
         SF: {{ offer.customer_sf }}
         SF2:  {{ offer.customer_sf2 }}
        </div>

                <!-- Card body -->
                <validation-observer
                  v-slot="{ handleSubmit }"
                  ref="formValidator"
                >
                  <form
                    class="needs-validation"
                    @submit.prevent="handleSubmit(firstFormSubmit)"
                  >
                    <customer
                      title="Kundendaten"
                      icon="fas fa-users"
                    ></customer>

                    <car
                      title="Fahrzeugdaten"
                      icon="fas fa-car"
                      v-if="offer.is_car"
                    ></car>
                    <van
                      title="Fahrzeugdaten"
                      icon="fas fa-van"
                      v-if="offer.is_van"
                    ></van>

                    <insurance
                  title="Informationen zur Versicherung"
                  icon="fas fa-info"
                  @init="initInsurance"
                ></insurance>

                  </form>
                </validation-observer>
              </card>
            </b-col>
          </b-row>

          <b-row class="card-wrapper">
            <template v-if="false">
              <b-col lg="12">
                <!--   options -->
                <options
                  title="Informationen zur Versicherung"
                  icon="fas fa-info"
                ></options>
              </b-col>
            </template>
          </b-row>
        </b-col>
        <b-col lg="6">
            <div class="loader" v-if="loading">
            </div>
            <pricing
       
                      title="pricing"
                      icon="fas fa-users" v-on:calculate="mayWeCalc()"
                    ></pricing>

                    <options
       
                      title="Optionen"
                      icon="fas fa-users"
                    ></options>

        </b-col>

        <b-col lg="12" v-if="false">
          <base-button
            type="primary"
            class="btn btn-primary"
            @click="submitToApi()"
            v-if="allDataValidated"
            >Jetzt kalkulieren</base-button
          >
        </b-col>
      </b-row>

      <!--modal :show.sync="offer.new_car_above_max">
        <h6 slot="header" class="modal-title">
          <i class="fas fa-university"></i>
          Angebot nicht möglich
        </h6>

        <p>
          Bitte kontaktieren sie die TLP-Wirtschaftsberatung um ein Fahrzeug mit
          einem Fahrzeugneuwert > 210.000 € zu versichern.
        </p>

        <template slot="footer">
          <div class="btn-wrapper text-center">
            <base-button type="primary" class="btn btn-info">
              <span
                class="btn-inner--text"
                v-on:click="offer.new_car_above_max = false"
                >OK</span
              >
            </base-button>
          </div>
        </template>
      </modal-->




      <!-- b-row>



        <b-col lg="6">
          <offer-info v-if="currentAccount.isAdmin"></offer-info>
        </b-col>

     <b-col lg="6">
          <calc-info v-if="currentAccount.isAdmin"></calc-info>
       </b-col>

      </b-row -->
    </b-container>


      <b-container fluid class="mt-2">
        
        RESULTING OFFERS
        
        <softfair-offers-list :offers="offer.softfair_offers"></softfair-offers-list>

     </b-container>
  </div>
</template>
<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import BaseSlider from "@/components/BaseSlider";
import { Modal, BaseAlert } from "@/components";
import swal from "sweetalert2";

import { Select, Option } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import Customer from "../cscomponents/avsoffer/Customer";
import Car from "../cscomponents/avsoffer/Car";
import Van from "../cscomponents/avsoffer/Van";
import Insurance from "../cscomponents/avsoffer/Insurance";
import Options from "../cscomponents/avsoffer/Options";
import Pricing from "../cscomponents/avsoffer/Pricing";

/** softfair stuff */
import SoftFairOffersList from "../cscomponents/softfair/SoftFairOffersList.vue";

/* debug */
import OfferInfo from "../cscomponents/OfferInfo";
import CalcInfo from "../cscomponents/CalcInfo";

import dateUtil from "../../services/date";
import offerUtil from "../../services/offer";

import { mapGetters, mapState, mapMutations, mapActions } from "vuex";

export default {
  components: {
    flatPicker,
    [Select.name]: Select,
    [Option.name]: Option,
    BasePagination,
    RouteBreadCrumb,
    BaseSlider,
    Modal,
    Customer,
    Car,
    Van,
    Insurance,
    Options,
    Pricing,
    OfferInfo,
    CalcInfo,
    SoftFairOffersList,
  },
  data() {
    return {
      loading: false,
      //token: false,
      offerdata: [],
      hsntsn: false,
      edtload: false,
      modals: {
        notice: false,
        lawyer: false,
        expertise: false,
        damageheight: false,
      },
    };
  },
  props: {
    token: String,
    title: "Kundenangebot rechnen",
    icon: "fa-user",
  },
  methods: {
    acceptOffer() {
      this.$router.push({
        name: "Angebot annehmen",
        params: { token: `${this.offer.id}` },
      })
    },
    toggleOfferType() {
      if (this.offer.is_car) {
        this.offer.is_car = false;
        this.offer.is_van = true;
      } else {
        this.offer.is_car = true;
        this.offer.is_van = false;
      }
    },
    toggleOfferCompany() {
      if (this.offer.is_company) {
        this.offer.is_company = false;
        this.offer.holder_id = 'N';
      } else {
        this.offer.is_company = true;
        this.offer.holder_id = 'N';
      }
      
    },
    retrieveOffer_old(token) {
      console.log("RETREIVING OFFER FOR EDIT");
      this.loading = true;
      this.$api
        .getOffer(token)
        .then((response) => {
          //this.offerdata = response.data.offer;
          //  this.offer = response.data.offer;

          console.log("LOGGING OFFER FOR EDIT");
          console.log(response.data.offer);
          console.log(this.offer);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // modals
    showCarValueNotice() {
      this.modals.carvalue = true;
    },

    logValidity() {
      return this.allDataValidated();
      console.log("Validity: lawyer -> " + this.offer.lawyerValidated);
      console.log(
        "Validity: damageheight -> " + this.offer.damageHeightValidated
      );
      console.log("Validity: date -> " + this.offer.desiredDateValidated);
      console.log("Validity: kind -> " + this.offer.damageKindValidated);
      console.log(
        "Validity: customeradd -> " + this.offer.customerAddressValidated
      );
      console.log(
        "Validity: billingadd -> " + this.offer.billingAddressValidated
      );
      console.log(
        "Validity: inspectionadd -> " + this.offer.inspectionAddressValidated
      );
      console.log("Validity: car -> " + this.offer.carDataValidated);
      console.log("Validity: opponent -> " + this.offer.opponentDataValidated);
      console.log("Validity: ALL -> " + this.offer.allValidated);
    },

    customerValidated() {
      console.log(
        "Validity: customer_firstname -> " + this.offer.customer_firstname
      );
/*
      if (!this.offer.customer_firstname) {
        return false;
      }
      console.log("Validity: title -> " + this.offer.title);
      if (!this.offer.title) {
        return false;
      }
      console.log(
        "Validity: customer_lastname -> " + this.offer.customer_lastname
      );
      if (!this.offer.customer_lastname) {
        return false;
      }
*/
      console.log("Validity: dob -> " + this.offer.dob);
      if (!this.offer.dob) {
        return false;
      }
      console.log("Validity: customer_zip -> " + this.offer.customer_zip);
      if (!this.offer.customer_zip) {
        return false;
      }
      console.log("Validity: has_holder -> " + this.offer.has_holder);
      if (!this.offer.has_holder) {
        return false;
      }
      return true;
    },
    carValidated() {},
    insuranceValidated() {},

    allDataValidated: function () {
      if (
        customerValidated()
        /*
        this.offer.lawyerValidated &&
        this.offer.damageHeightValidated &&
        this.offer.desiredDateValidated &&
        this.offer.damageKindValidated &&
        this.offer.customerAddressValidated &&
        this.offer.billingAddressValidated &&
        this.offer.inspectionAddressValidated &&
        this.offer.carDataValidated &&
        this.offer.opponentDataValidated
        */
      ) {
        this.offer.allValidated = true;
        console.log("VALID WE'RE MOVING");
       // submitToApi();
        return true;
      }
    },

    slogValidity() {
      this.submitToApi();
    },

    retrieveOffer(token) {

      console.log("RETRIVING OFFER");
        this.zeroPrice();

      this.edtload = true;
      this.loading = true;
      this.$api
        .getOffer(token)
        .then((response) => {

            console.log("THE complete response");
          console.log(response);
          console.log("THE pricing response");
          console.log(response.data.pricing);
          console.log(response.data.offer.pricing);

          //console.log(this.offer);  
          this.offerdata = response.data.offer;
          //console.log(response.data.offer);
//          this.offer = response.data.offer;
            if(response.data.offer.pricing){
                this.offer.pricing = response.data.offer.pricing;
            }
          
          this.kravag_ready = true;
          console.log("THE offer");
          console.log(this.offer);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
          this.edtload = false;
        });
    },
    fetchParticipations() {
      this.loading = true;
      let qtp = "car";
      if (this.offer.is_van) {
        qtp = 'van';
      }
      this.$api
        .getParticipations(qtp)
        .then((response) => {
          this.offer.participations = response.data.items.map((item) => {
            let str = "";

            if (item.vk > 0) {
              str += "Vollkasko SB " + item.vk + " ";
            }
            
            //if (true) {
            str += "Teilkasko SB " + item.tk + " ";
            //} 

            if (item.name == "Nur Haftpflicht") {
              str = item.name;
            }

            return { value: item.id, label: str };
          });
        })
        .catch((e) => {
          //console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    fetchPaymentterms() {
      this.loading = true;
      this.$api
        .getPaymentterms()
        .then((response) => {
        //  //console.log(response);
          this.offer.paymentterms = response.data.items.map((item) => {
            return { value: item.id, label: item.name };
          });
        })
        .catch((e) => {
          //console.log(e);
        })
        .finally(() => {
          //console.log(this.offer.paymentterms);
          //console.log(this.offer.paymentterm);
          this.offer.paymentterm = this.offer.paymentterms[0].value;
          this.loading = false;
          //console.log(this.offer.paymentterm);
        });
    },

    fetchInsurances() {
      this.loading = true;
      this.$api
        .getInsurances()
        .then((response) => {
        //  //console.log(response);
          this.insurances = response.data.items.map((item) => {
            return { value: item.id, label: item.vu_name };
          });
        })
        .catch((e) => {
          //console.log(e);
        })
        .finally(() => {
         // this.offer.insurance_id = this.offer.insurances[0].id;
          this.loading = false;
        });
    },

    // send via apollo
    submitToApi() {
         this.zeroPrice();
         this.edtload = true;
      this.loading = true;
      this.$api
        .createOffer(this.offer)
        .then((response) => {
          //console.log(response);
          //offerId = response.data.id;
          console.log(response.data.id);
          console.log(response.data.pricing);
          this.offer.id = response.data.id;
          this.retrieveOffer(this.offer.id);
          //this.offer.offers = response.data.pricing;
          //this.$router.push({ path: `/offers/${response.data.id}` });
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
          this.edtload = false;
        });
    },

    zeroPrice(){
        this.offer.pricing = {};
        
        /*this.offer.pricing.product_hf_desc = '';
        this.offer.pricing.product_vk_desc = '';
        this.offer.pricing.product_tkasko_desc = '';
this.offer.pricing.product_hf_net = '';
this.offer.pricing.product_vk_net = '';
this.offer.pricing.product_tkasko_net = '';
            this.offer.pricing.price_brut_complete = '';
            this.offer.pricing.price_tax_complete = '';
            */
    },

    mayWeCalc(){
        this.hsntsn = false;

      console.log("VALIDITY edtload -> " + this.edtload);
      if(this.edtload){
        return false
      }

      if(!this.offer.is_company){
        console.log("Validity: dob -> " + this.offer.dob);
        if (!this.offer.dob) {
          return false;
        }
      }
      console.log("Validity: customer_zip -> " + this.offer.customer_zip);
      if (!this.offer.customer_zip) {
        return false;
      }
      console.log("Validity: has_holder -> " + this.offer.has_holder);
      if (this.offer.has_holder) {
        console.log("Validity: holder_zip if -> " + this.offer.holder_zip);
        if (!this.offer.holder_zip) {
            return false;
        }
      }

      if(this.offer.is_car){
        console.log("Validity: hsn -> " + this.offer.hsn);
        if (this.offer.hsn && this.offer.hsn.length == 4 && this.offer.tsn && this.offer.tsn.length == 3) {
            this.hsntsn = true;
            //return false;
        }
      }

      console.log("Validity: car_first_registration -> " + this.offer.car_first_registration);
      if (!this.offer.car_first_registration) {
        return false;
      }
      console.log("Validity: car_registration -> " + this.offer.car_registration);
      if (!this.offer.car_registration) {
        return false;
      }
      console.log("Validity: insurance_start -> " + this.offer.insurance_start);
      if (!this.offer.insurance_start) {
        return false;
      }

      console.log("Validity: customer_sf -> " + this.offer.customer_sf);
      console.log("Validity: customer_sf -> " + (this.offer.customer_sf === ""));
      if (this.offer.customer_sf === "") {
        console.log("Validity: customer_sf -> " + this.offer.customer_sf === "");
        return false;
      }
      console.log("Validity: customer_sf2 -> " + this.offer.customer_sf2);
      if (this.offer.customer_sf2 === '') {
        return false;
      }

      console.log("Validity: mileage -> " + this.offer.mileage);
      if (!this.offer.mileage) {
        return false;
      }
      console.log("Validity: participation -> " + this.offer.participation);
      if (!this.offer.participation) {
        return false;
      }
      console.log("Validity: paymentterm -> " + this.offer.paymentterm);
      if (!this.offer.paymentterm) {
        return false;
      }
      console.log("IF has_second_vehicle -> " + this.offer.has_second_vehicle);
      if(this.offer.has_second_vehicle != 0){
        console.log("Validity: second_vehicle_holder -> " + this.offer.second_vehicle_holder);
        if(this.offer.second_vehicle_holder == ''){
            return false;
        }
        console.log("Validity: sf_holder_sf -> " + this.offer.sf_holder_sf);
        if(this.offer.sf_holder_sf == ''){
           // return false;
        }
        console.log("Validity: insurance_id -> " + this.offer.insurance_id);
        if(this.offer.insurance_id == ''){
            return false;
        }
      }
      console.log("Validity: body_id -> " + this.offer.body_id);
      if(this.offer.is_van){
        if(!this.offer.body_id){
          return false;
        }
      }

      if(this.hsntsn || this.offer.is_van){
        if(this.edtload === false){
        this.submitToApi();
        }
      }

      /*
      console.log("Validity: has_free_sfr -> " + this.offer.has_free_sfr);
      if (!this.offer.has_free_sfr) {
        return false;
      }
      */
      
//      return true;
    },

    setInsurance(insi){
      this.offer.slected_insurance = insi;

    },
    initInsurance(){
      //  this.setDefaults();
    },
    setDefaults(){
      this.edtload = true;
    this.$store.dispatch("resetOffer");

    this.offer.customer_sf = '';
    this.offer.customer_sf2 = '';
    this.offer.is_car = true;
    this.offer.is_company = false;
    this.offer.has_holder = 0;
    this.offer.customer_has_free_sfr = 1;
    this.offer.holder_only_driver = 1;
    this.offer.mileage = 10000;
    this.offer.participation = 114; // = 10000;
    this.offer.paymentterm = 73; // = 10000;


    this.offer.insurance_number = '';
    this.offer.insurance_id = '';

    this.offer.street = '';
    this.offer.number = '';
    this.offer.customer_street = '';
    this.offer.customer_number = '';
    this.offer.address.street = '';
    this.offer.address.number = '';




    var date = new Date();

    var month = ('0' + (date.getMonth() + 1)).slice(-2);
    var day   = ('0' + date.getDate()).slice(-2);
    var year  = date.getFullYear();

    var htmlDate = year + '-' + month + '-' + day;
    console.log("THEDATE: "+htmlDate);

    this.offer.car_first_registration = htmlDate;
    this.offer.car_registration = htmlDate;
    this.offer.insurance_start = htmlDate;


    console.log(this.offer.insurance_start);
    console.log(this.$sidebar);

      if (!this.$sidebar.isMinimized) {
        this.$sidebar.toggleMinimize();
      }
      this.edtload = false;

      this.fetchParticipations();
    this.fetchPaymentterms();
    //this.setDefaultDates();
    this.fetchInsurances();

    if(this.offer.is_company == 1){
      this.offer.second_vehicle_holder = this.offer.possible_sf_holders_company[0].label;
    }

    }
    
  },
  computed: {
    ...mapGetters({ currentAccount: "currentAccount" }),
    ...mapState({
      offer: (state) => state.offer,
    }),
    ...mapActions({
      resetOffer: (state) => state.resetOffer,
    }),

    maySave: function () {
      return this.allDataValidated();
    },

    sallDataValidated: function () {
      return true;
    },
    allValidated: (state) => state.offer.allValidated,

     // offer: (state) => state.offer,

      customer_zip: (state) => state.offer.customer_zip,
      customer_dob: (state) => state.offer.car_value,

      has_holder: (state) => state.offer.has_holder,
      holder_zip: (state) => state.offer.holder_zip,

      hsn: (state) => state.offer.hsn,
      tsn: (state) => state.offer.tsn,


      car_first_registration: (state) => state.offer.car_first_registration,
      car_registration: (state) => state.offer.car_registration,
      insurance_start: (state) => state.offer.insurance_start,
      mileage: (state) => state.offer.mileage,

      participation: (state) => state.offer.participation,
      paymentterm: (state) => state.offer.paymentterm,

      customer_sf: (state) => state.offer.customer_sf,
      customer_sf2: (state) => state.offer.customer_sf2,
      is_company: (state) => state.offer.is_company,

youngest_driver_dob: (state) => state.offer.youngest_driver_dob,
oldest_driver_dob: (state) => state.offer.oldest_driver_dob,
license_date: (state) => state.offer.license_date,

has_free_sfr: (state) => state.offer.has_free_sfr,



    option_schutzbrief: (state) => state.offer.option_schutzbrief,
    option_schutzbrief_plus: (state) => state.offer.option_schutzbrief_plus,
    option_gap: (state) => state.offer.option_gap,
    option_discount_protection: (state) => state.offer.option_discount_protection,
    option_gap_helvetia: (state) => state.offer.option_gap_helvetia,
    option_fahrerschutz: (state) => state.offer.option_fahrerschutz,
    option_kex: (state) => state.offer.option_kex,
    option_owndamage: (state) => state.offer.option_owndamage,
    option_discount_protection_kh: (state) => state.offer.option_discount_protection_kh,
    option_discount_protection_fv: (state) => state.offer.option_discount_protection_fv,

    has_second_vehicle: (state) => state.offer.has_second_vehicle,
    second_vehicle_holder: (state) => state.offer.second_vehicle_holder,
    sf_holder_sf: (state) => state.offer.sf_holder_sf,
    insurance_id: (state) => state.offer.insurance_id,


    is_van: (state) => state.offer.is_van,


/*
      only driver ext
      free_sfr: (state) => state.offer.car_value,






WENN offer.has_second_vehicle dann
if(offer.second_vehicle_holder
if(offer.sf_holder_sf
if(offer.insurance_id

      car_value: (state) => state.offer.car_value,
      car_usage: (state) => state.offer.car_usage,
      car_hsn: (state) => state.offer.hsn,
      car_tsn: (state) => state.offer.tsn,
      second_vehicle: (state) => state.offer.has_second_vehicle,
      only_driver: (state) => state.offer.holder_only_driver,
      dob: (state) => state.offer.dob,
      has_holder: (state) => state.offer.has_holder,
      holder_id: (state) => state.offer.holder_id,
      car_first_registration: (state) => state.offer.car_first_registration,
      mileage: (state) => state.offer.mileage,
      insurance_start: (state) => state.offer.insurance_start,
      participation: (state) => state.offer.participation,
      paymentterm: (state) => state.offer.paymentterm,
      */

  },

  watch: {
            '$route' (to, from) {
                //on route change re run: onCreated
                this.setDefaults();

            },

            is_van(newValue, oldValue) {
      this.fetchParticipations();
    },

second_vehicle_holder(newValue, oldValue) {
      console.log('queryParameter license_date changed -> running apply_rules:');
      //console.log(offerUtil.apply_rules(this.offer));
      this.mayWeCalc();
    },
sf_holder_sf(newValue, oldValue) {
      console.log('queryParameter license_date changed -> running apply_rules:');
      //console.log(offerUtil.apply_rules(this.offer));
      this.mayWeCalc();
    },
insurance_id(newValue, oldValue) {
      console.log('queryParameter license_date changed -> running apply_rules:');
      //console.log(offerUtil.apply_rules(this.offer));
      this.mayWeCalc();
    },

    has_free_sfr(newValue, oldValue) {
      console.log('queryParameter has_free_sfr changed -> running apply_rules:');
      console.log(`Updating has_free_sfr from ${oldValue} to ${newValue}`);
      console.log(`WE MAY CALCULATE Now`);
      this.mayWeCalc();
    },


license_date(newValue, oldValue) {
      console.log('queryParameter license_date changed -> running apply_rules_tvs:');
      //console.log(offerUtil.apply_rules(this.offer));
      //console.log(offerUtil.apply_rules(this.offer));
      this.mayWeCalc();
    },

youngest_driver_dob(newValue, oldValue) {
      //console.log('queryParameter changed -> running apply_rules:');
     //console.log(offerUtil.apply_rules(this.offer));
     this.mayWeCalc();
    },

    has_second_vehicle(newValue, oldValue) {
      //console.log('queryParameter changed -> running apply_rules:');
      //console.log(offerUtil.apply_rules(this.offer));
      console.log(`Updating has_second_vehicle from ${oldValue} to ${newValue}`);
      console.log(`WE MAY CALCULATE Now`);
      this.mayWeCalc();
    },

    oldest_driver_dob(newValue, oldValue) {
      //console.log('queryParameter changed -> running apply_rules:');
      //console.log(offerUtil.apply_rules(this.offer));
      this.mayWeCalc();
    },

      customer_zip(newValue, oldValue) {
      console.log(`Updating allValidated from ${oldValue} to ${newValue}`);
      console.log(`WE MAY CALCULATE Now`);
      this.mayWeCalc();
    },
      customer_dob(newValue, oldValue) {
      console.log(`Updating allValidated from ${oldValue} to ${newValue}`);
      console.log(`WE MAY CALCULATE Now`);
      this.mayWeCalc();
    },
      has_holder(newValue, oldValue) {
      console.log(`Updating allValidated from ${oldValue} to ${newValue}`);
      console.log(`WE MAY CALCULATE Now`);
      this.mayWeCalc();
    },
      holder_zip(newValue, oldValue) {
      console.log(`Updating allValidated from ${oldValue} to ${newValue}`);
      console.log(`WE MAY CALCULATE Now`);
      this.mayWeCalc();
    },
      hsn(newValue, oldValue) {
      console.log(`Updating allValidated from ${oldValue} to ${newValue}`);
      console.log(`WE MAY CALCULATE Now`);
      this.mayWeCalc();
    },
      tsn(newValue, oldValue) {
      console.log(`Updating allValidated from ${oldValue} to ${newValue}`);
      console.log(`WE MAY CALCULATE Now`);
      this.mayWeCalc();
    },
      car_first_registration(newValue, oldValue) {
      console.log(`Updating car_first_registration from ${oldValue} to ${newValue}`);
      console.log(`WE MAY CALCULATE Now`);
      this.mayWeCalc();
    },
      car_registration(newValue, oldValue) {
      console.log(`Updating car_registration from ${oldValue} to ${newValue}`);
      console.log(`WE MAY CALCULATE Now`);
      this.mayWeCalc();
    },
      insurance_start(newValue, oldValue) {
      console.log(`Updating insurance_start from ${oldValue} to ${newValue}`);
      console.log(`WE MAY CALCULATE Now`);
      this.mayWeCalc();
    },
      mileage(newValue, oldValue) {
      console.log(`Updating allValidated from ${oldValue} to ${newValue}`);
      console.log(`WE MAY CALCULATE Now`);
      this.mayWeCalc();
    },
      participation(newValue, oldValue) {
      console.log(`Updating allValidated from ${oldValue} to ${newValue}`);
      console.log(`WE MAY CALCULATE Now`);
      this.mayWeCalc();
    },
      paymentterm(newValue, oldValue) {
      console.log(`Updating allValidated from ${oldValue} to ${newValue}`);
      console.log(`WE MAY CALCULATE Now`);
      this.mayWeCalc();
    },
      customer_sf(newValue, oldValue) {
      console.log(`Updating allValidated from ${oldValue} to ${newValue}`);
      console.log(`WE MAY CALCULATE Now`);
      this.mayWeCalc();
    },
      customer_sf2(newValue, oldValue) {
      console.log(`Updating allValidated from ${oldValue} to ${newValue}`);
      console.log(`WE MAY CALCULATE Now`);
      this.mayWeCalc();
    },

      is_company(newValue, oldValue) {
      console.log(`Updating allValidated from ${oldValue} to ${newValue}`);
      console.log(`WE MAY CALCULATE Now`);
      // set car usage gewerblich or private
      if(oldValue == "0"){
          this.offer.car_usage = "Gewerblich";
      }
      else{
          this.offer.car_usage = "Privat";
      }
      this.mayWeCalc();
    },


    option_schutzbrief(newValue, oldValue) {
      this.mayWeCalc();
    },
    option_schutzbrief_plus(newValue, oldValue) {
      this.mayWeCalc();
    },
    option_gap(newValue, oldValue) {
      this.mayWeCalc();
    },
    option_discount_protection(newValue, oldValue) {
      this.mayWeCalc();
    },
    option_gap_helvetia(newValue, oldValue) {
      this.mayWeCalc();
    },
    option_fahrerschutz(newValue, oldValue) {
      this.mayWeCalc();
    },
    option_kex(newValue, oldValue) {
      this.mayWeCalc();
    },
    option_owndamage(newValue, oldValue) {
      this.mayWeCalc();
    },
    option_discount_protection_kh(newValue, oldValue) {
      this.mayWeCalc();
    },
    option_discount_protection_fv(newValue, oldValue) {
      this.mayWeCalc();
    },



    allValidated(newValue, oldValue) {
      console.log(`Updating allValidated from ${oldValue} to ${newValue}`);
      console.log(`WE MAY CALCULATE Now`);
      //this.mayFetchCar();
    },

    reallyFinished: function () {
      if (this.allDataValidated) {
        this.offer.allValidated = true;
        console.log("VALID WE'RE MOVING");
      }
    },
  },

  mounted: function () {
    this.setDefaults();

    if (this.$route.params.token) {
      this.zeroPrice();

this.edtload = true;

      this.loading = true;
      this.$store.dispatch("fetchOffer", this.$route.params.token).then(() => {
        this.loading = false;
      }).then(() => {
          this.loading = false;
          this.edtload = false;
          this.kravag_ready = true;
    this.offer.slected_insurance = 'softfair';

          console.log("ISCAR ------> ");
        console.log(this.offer.is_car);
        console.log("ISVAN ------> ");
        console.log(this.offer.is_van);

        console.log(offerUtil.apply_rules(this.offer));



        });
      console.log("fetchedOFFFFER");
      console.log(this.offer);
      if(this.offer.is_company){
        this.offer.nationality = 'D';
      }
    }




    if (this.$route.params.tokensssssss) {
      console.log("GOTTHETOKEN");
        this.zeroPrice();

        this.edtload = true;
      
      this.loading = true;

      this.$api
        .getOffer(this.$route.params.token)
        .then((response) => {


          //console.log(this.offer);  
          this.offerdata = response.data.offer;
          console.log(response.data.offer);
//          this.offer = response.data.offer;
            if(this.$route.params.token){
                this.offer.id = this.$route.params.token;
            }
            // ignore all van stuff
            if(response.data.offer.is_car){
                this.offer.is_van = false;
                this.offer.is_car = response.data.offer.is_car;
            }
            // ignore and zero all car stuff
            if(response.data.offer.is_van){
                this.offer.is_car = false;
                this.offer.is_van = response.data.offer.is_van;
                this.offer.hsn = '';
                this.offer.tsn = '';
                this.offer.maker = '';
                this.offer.brand = '';
                this.offer.model = '';
            }
            // set company and remove all non relevant stuff
            if(response.data.offer.is_company){
                this.offer.is_company = response.data.offer.is_company;
            }
            if(response.data.offer.company_name){
                this.offer.company_name = response.data.offer.company_name;
            }
            if(response.data.offer.firstname){
                this.offer.firstname = response.data.offer.firstname;
            }
            if(response.data.offer.lastname){
                this.offer.lastname = response.data.offer.lastname;
            }
            if(response.data.offer.pricing){
                this.offer.pricing = response.data.offer.pricing;
            }
            if(response.data.offer.holder_id){
                this.offer.holder_id = response.data.offer.holder_id;
            }
            if(response.data.offer.has_holder){
                this.offer.has_holder = response.data.offer.has_holder;
            }
            if(response.data.offer.holder_zip){
                this.offer.holder_zip = response.data.offer.holder_zip;
            }
            if(response.data.offer.holder_city){
                this.offer.holder_city = response.data.offer.holder_city;
            }
            if(response.data.offer.paymentterm){
                this.offer.paymentterm = response.data.offer.paymentterm;
            }
            if(response.data.offer.participation){
                this.offer.participation = response.data.offer.participation;
            }
            if(response.data.offer.holder_only_driver){
                this.offer.holder_only_driver = response.data.offer.holder_only_driver;
            }

            if(response.data.offer.holder_kravag_location_id){
                this.offer.holder_kravag_location_id = response.data.offer.holder_kravag_location_id;
            }

            if(response.data.offer.customer_has_free_sfr){
                this.offer.customer_has_free_sfr = response.data.offer.customer_has_free_sfr;
            }
            if(response.data.offer.has_second_vehicle){
                this.offer.has_second_vehicle = response.data.offer.has_second_vehicle;
            }
            if(response.data.offer.license_date){
                this.offer.license_date = response.data.offer.license_date;
            }
            if(response.data.offer.customer_sf){
                this.offer.customer_sf = response.data.offer.customer_sf;
            }
            if(response.data.offer.customer_sf2){
                this.offer.customer_sf2 = response.data.offer.customer_sf2;
            }
            if(response.data.offer.customer_zip){
                this.offer.customer_zip = response.data.offer.customer_zip;
            }
            if(response.data.offer.dob){
                this.offer.dob = response.data.offer.dob;
            }

            if(response.data.offer.hsn){
                this.offer.hsn = response.data.offer.hsn;
            }
            if(response.data.offer.tsn){
                this.offer.tsn = response.data.offer.tsn;
            }
            if(response.data.offer.car_first_registration){
                this.offer.car_first_registration = response.data.offer.car_first_registration;
            }
            if(response.data.offer.insurance_start){
                this.offer.insurance_start = response.data.offer.insurance_start;
            }
            if(response.data.offer.car_registration){
                this.offer.car_registration = response.data.offer.car_registration;
            }
            if(response.data.offer.mileage){
                this.offer.mileage = response.data.offer.mileage;
            }
            if(response.data.offer.option_schutzbrief){
                this.offer.option_schutzbrief = response.data.offer.option_schutzbrief;
            }
            if(response.data.offer.option_schutzbrief_plus){
                this.offer.option_schutzbrief_plus = response.data.offer.option_schutzbrief_plus;
            }
            if(response.data.offer.option_gap){
                this.offer.option_gap = response.data.offer.option_gap;
            }
            if(response.data.offer.option_discount_protection){
                this.offer.option_discount_protection = response.data.offer.option_discount_protection;
            }
            if(response.data.offer.option_fahrerschutz){
                this.offer.option_fahrerschutz = response.data.offer.option_fahrerschutz;
            }
            if(response.data.offer.option_kex){
                this.offer.option_kex = response.data.offer.option_kex;
            }
            if(response.data.offer.option_owndamage){
                this.offer.option_owndamage = response.data.offer.option_owndamage;
            }
            if(response.data.offer.option_discount_protection_kh){
                this.offer.option_discount_protection_kh = response.data.offer.option_discount_protection_kh;
            }
            if(response.data.offer.option_discount_protection_fv){
                this.offer.option_discount_protection_fv = response.data.offer.option_discount_protection_fv;
            }

            if(response.data.offer.youngest_driver_dob){
                this.offer.youngest_driver_dob = response.data.offer.youngest_driver_dob;
            }
            if(response.data.offer.oldest_driver_dob){
                this.offer.oldest_driver_dob = response.data.offer.oldest_driver_dob;
            }

            if(response.data.offer.body_id){
                this.offer.body_id = response.data.offer.body_id;
            }

            if(response.data.offer.car_kw){
                this.offer.car_kw = response.data.offer.car_kw;
            }

            // address
            if(response.data.offer.title){
                this.offer.title = response.data.offer.title;
            }
            
            if(response.data.offer.address.city){
                this.offer.address.city = response.data.offer.address.city;
            }
            if(response.data.offer.address.street){
                this.offer.address.street = response.data.offer.address.street;
            }
            if(response.data.offer.address.number){
                this.offer.address.number = response.data.offer.address.number;
            }
            if(response.data.offer.address.zip){
                this.offer.address.zip = response.data.offer.address.zip;
            }
            if(response.data.offer.address.email){
                this.offer.address.email = response.data.offer.address.email;
            }
            

            if(response.data.offer.city){
                this.offer.city = response.data.offer.city;
            }
            if(response.data.offer.customer_city){
                this.offer.customer_city = response.data.offer.customer_city;
            }


            if(response.data.offer.vin){
                this.offer.vin = response.data.offer.vin;
            }
            if(response.data.offer.plate){
                this.offer.plate = response.data.offer.plate;
            }



            if(response.data.offer.kravag_payment_mode){
                this.offer.kravag_payment_mode = response.data.offer.kravag_payment_mode;
            }
            if(response.data.offer.iban){
                this.offer.iban = response.data.offer.iban;
            }
            if(response.data.offer.forgein_bank_owner){
                this.offer.forgein_bank_owner = response.data.offer.forgein_bank_owner;
            }
            if(response.data.offer.forgein_bank_owner_firstname){
                this.offer.forgein_bank_owner_firstname = response.data.offer.forgein_bank_owner_firstname;
            }
            if(response.data.offer.forgein_bank_owner_lastname){
                this.offer.forgein_bank_owner_lastname = response.data.offer.forgein_bank_owner_lastname;
            }
            if(response.data.offer.forgein_bank_owner_street){
                this.offer.forgein_bank_owner_street = response.data.offer.forgein_bank_owner_street;
            }
            if(response.data.offer.forgein_bank_owner_number){
                this.offer.forgein_bank_owner_number = response.data.offer.forgein_bank_owner_number;
            }
            if(response.data.offer.forgein_bank_owner_zip){
                this.offer.forgein_bank_owner_zip = response.data.offer.forgein_bank_owner_zip;
            }
            if(response.data.offer.forgein_bank_owner_city){
                this.offer.forgein_bank_owner_city = response.data.offer.forgein_bank_owner_city;
            }

            if(response.data.offer.insurance_number){
                this.offer.insurance_number = response.data.offer.insurance_number;
            }
            if(response.data.offer.insurance_id){
                this.offer.insurance_id = response.data.offer.insurance_id;
            }



            if(response.data.offer.sf_holder_sf){
                this.offer.sf_holder_sf = response.data.offer.sf_holder_sf;
            }
            if(response.data.offer.second_vehicle_holder){
                this.offer.second_vehicle_holder = response.data.offer.second_vehicle_holder;
            }
            if(response.data.offer.insurance_id){
                this.offer.insurance_id = response.data.offer.insurance_id;
            }


            



          this.kravag_ready = true;
          
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
          this.edtload = false;


          console.log("ISCAR ------> ");
        console.log(this.offer.is_car);
        console.log("ISVAN ------> ");
        console.log(this.offer.is_van);

        console.log(offerUtil.apply_rules(this.offer));



        });


        console.log("ISCAR ------> ");
        console.log(this.offer.is_car);
        console.log("ISVAN ------> ");
        console.log(this.offer.is_van);

    } 


  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      //if (mutation.type === 'updateStatus') {
        console.log(`Updating to ${state}`);

        // Do whatever makes sense now
   //     if (state.status === 'success') {
   //       this.complex = {
   //         deep: 'some deep object',
   //       };
    //    }
     // }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
};
</script>
<style>
.spinner {
  width: 40px;
  height: 40px;

  margin: 100px auto;
  z-index: 10000000;
/*  display: none;*/

  position: absolute;
  top: 0px;
  right: 0px;
  width: 100%;
  height: 100%;

}

.double-bounce1, .double-bounce2 {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #333;
  opacity: 0.6;
  position: absolute;
  top: 50%;
  left: 50%;
  
  -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
  animation: sk-bounce 2.0s infinite ease-in-out;
}

.double-bounce2 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

@-webkit-keyframes sk-bounce {
  0%, 100% { -webkit-transform: scale(0.0) }
  50% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bounce {
  0%, 100% { 
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  } 50% { 
    transform: scale(1.0);
    -webkit-transform: scale(1.0);
  }
}
</style>